import React, { useEffect, createContext, useReducer, useContext } from 'react';
import Breadcrumb from '../../shared/Breadcrumb';
import SortByDropDown from '../../shared/SortByDropdown'
import SearchFilter from './SearchFilter';
import axios from 'axios';
import { AuthContext } from '../../../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { apiRoutes } from '../../../AppSettings';
import Util from '../../../Util';
import alertify from "alertifyjs";

export const FilterContext = createContext();

const SORT_BY = 'SORT_BY';
const GENDER_LIST = 'GENDER_LIST';
const SPECIALIST_LIST = 'SPECIALIST_LIST';
const SEARCH_RESULT = 'SEARCH_RESULT';

const initialState = {
	sort: 'Rating',
	gender: '',
	specialist: '',
	searchResult: []
};

const reducer = (state, action) => {
	switch (action.type) {
		case SORT_BY:
			return { ...state, sort: action.sortBy }
		case GENDER_LIST:
			return { ...state, gender: action.genderList }
		case SPECIALIST_LIST:
			return { ...state, specialist: action.specialistList }
		case SEARCH_RESULT:
			return { ...state, searchResult: action.searchResult }
		default:
			return state;
	}
}

const Search = () => {
	const { userState } = useContext(AuthContext);
	const [state, dispature] = useReducer(reducer, initialState);

	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'Authorization': 'bearer ' + userState.token
		}
	};

	const searchRequest = (filter) => {

		let initialValue = {
			gender: { male: false, female: false },
			specialist: { urology: false, neurology: false, dentist: false, orthopedic: false, cardiologist: false }
		};

		if (filter != undefined) {
			initialValue = filter;
		}

		axios.post(apiRoutes.getfiltered, JSON.stringify(initialValue), options)
			.then((response) => {
				if (response.status === 200) {
					const data = response.data;
					console.log(data);
					dispature({ type: SEARCH_RESULT, searchResult: data });
				}
			}, (error) => {
				console.log(error);
				//alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
			});
	}

	useEffect(() => {
		searchRequest();
	}, []);


	const sortByChangeHandler = (e) => {
		console.log('h2')
	}

	const searchHandler = (filter) => {
		console.log(filter)
		searchRequest(filter);
	}

	return (
		<FilterContext.Provider value={{ state, dispature, searchHandler, sortByChangeHandler }}>
			<Breadcrumb title="Search Doctors">
				{
					/* <SortByDropDown sortByChangeHandler={sortByChangeHandler} />*/
				}

			</Breadcrumb>
			<div className="content">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-12 col-lg-4 col-xl-3 theiaStickySidebar">
							<SearchFilter title='test' searchHandler={searchHandler} />
						</div>
						<div className="col-md-12 col-lg-8 col-xl-9">
							{
								state.searchResult &&
								state.searchResult.map(doc => (
									<div className="card">
										<div className="card-body">
											<div className="doctor-widget">
												<div className="doc-info-left">
													<div className="doctor-img">
														<Link to={
															{
																pathname: `/doctorprofile`,
																state: {
																	selectedDoctor: JSON.stringify(doc)
																}
															}
														}>
															<img src={Util.loadImage(doc.profileImage)} className="img-fluid" alt="User Image" />
														</Link>
													</div>
													<div className="doc-info-cont">
														<h4 className="doc-name">
															<Link to={
																{
																	pathname: `/doctorprofile`,
																	state: {
																		selectedDoctor: JSON.stringify(doc)
																	}
																}
															}>
																Dr. {doc.firstName} {doc.lastName}
															</Link></h4>
														<p className="doc-speciality">{doc.subTitle}</p>
														<h5 className="doc-department"><img src="assets/img/specialities/specialities-05.png" className="img-fluid" alt="Speciality" />{doc.category}</h5>
														<div className="rating">
															<i className="fas fa-star filled"></i>
															<i className="fas fa-star filled"></i>
															<i className="fas fa-star filled"></i>
															<i className="fas fa-star filled"></i>
															<i className="fas fa-star"></i>
															<span className="d-inline-block average-rating">(17)</span>
														</div>
														<div className="clinic-details">
															<p className="doc-location"><i className="fas fa-map-marker-alt"></i> Florida, USA</p>
															<ul className="clinic-gallery">
																<li>
																	<a href="assets/img/features/feature-01.jpg" data-fancybox="gallery">
																		<img src="assets/img/features/feature-01.jpg" alt="Feature" />
																	</a>
																</li>
																<li>
																	<a href="assets/img/features/feature-02.jpg" data-fancybox="gallery">
																		<img src="assets/img/features/feature-02.jpg" alt="Feature" />
																	</a>
																</li>
																<li>
																	<a href="assets/img/features/feature-03.jpg" data-fancybox="gallery">
																		<img src="assets/img/features/feature-03.jpg" alt="Feature" />
																	</a>
																</li>
																<li>
																	<a href="assets/img/features/feature-04.jpg" data-fancybox="gallery">
																		<img src="assets/img/features/feature-04.jpg" alt="Feature" />
																	</a>
																</li>
															</ul>
														</div>
														<div className="clinic-services">
															<span>Dental Fillings</span>
															<span> Whitneing</span>
														</div>
													</div>
												</div>
												<div className="doc-info-right">
													<div className="clini-infos">
														<ul>
															<li><i className="far fa-thumbs-up"></i> 98%</li>
															<li><i className="far fa-comment"></i> 17 Feedback</li>
															<li><i className="fas fa-map-marker-alt"></i> Florida, USA</li>
															<li><i className="far fa-money-bill-alt"></i> $300 - $1000 <i className="fas fa-info-circle" data-toggle="tooltip" title="Lorem Ipsum"></i> </li>
														</ul>
													</div>
													<div className="clinic-booking">
														<Link className="view-pro-btn" to={
															{
																pathname: `/doctorprofile`,
																state: {
																	selectedDoctor: JSON.stringify(doc)
																}
															}
														}>View Profile</Link>
														<Link className="apt-btn" to={
															{
																pathname: `/booking`,
																state: {
																	selectedDoctor: JSON.stringify(doc)
																}
															}
														} >Book Appointment</Link>
													</div>
												</div>
											</div>
										</div>
									</div>
								))
							}
						</div>
					</div>
				</div>
			</div>
		</FilterContext.Provider>
	);
}

export default Search;